import React from "react";
import { connect } from "react-redux";
import Button from "../Button";
import * as dashboard from "../../modules/dashboard";
import * as styles from "../../styles/components/TestActionButton.css";

function TestActionButton({ wevo, editTest, viewResults, viewDetails }) {
    const ACTIONS = {
        edit: {
            label: "Edit",
            color: "primary",
            onClick: editTest
        },
        details: {
            label: "View",
            color: "primary",
            onClick: viewDetails
        },
        results: {
            label: "View Results",
            color: "success",
            onClick: viewResults
        }
    };

    const ACTIONS_BY_STATUS = {
        draft: ACTIONS.edit,
        running: ACTIONS.details,
        pending: ACTIONS.details,
        completed: ACTIONS.results
    };

    const action = ACTIONS_BY_STATUS[wevo.status];

    return (
        <div className={styles.buttonContainer}>
            <Button
                color={action.color}
                wrapperClass={styles.button}
                onClick={action.onClick}
            >
                <span>{action.label}</span>
            </Button>
        </div>
    );
}

function mapDispatchToProps(dispatch, props) {
    return {
        editTest: () => dispatch(dashboard.editTest(props.wevo)),
        viewDetails: () => dispatch(dashboard.viewTestDetails(props.wevo)),
        viewResults: () => dispatch(dashboard.viewTestResults(props.wevo))
    };
}
export default connect(
    null,
    mapDispatchToProps
)(TestActionButton);



// WEBPACK FOOTER //
// ./src/components/Dashboard/TestActionButton.js